module.exports = __webpack_public_path__ + "media/21.ec7dd572.wav";